import type { ReactNode, SVGProps } from "react";

/**
 * The design's icons, path for path from the artboards: a 24 unit box,
 * 1.7 stroke for the nav, round caps and joins. Each takes a className
 * for its size and colour, and is hidden from assistive tech: a control
 * that carries one has its own label.
 */
export type IconProps = Omit<SVGProps<SVGSVGElement>, "children"> & { strokeWidth?: number };

/** The outlined frame every stroked icon draws in. */
export function Stroke({
    strokeWidth,
    className = "size-4",
    children,
    ...props
}: IconProps & { strokeWidth: number; children: ReactNode }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className={className}
            {...props}
        >
            {children}
        </svg>
    );
}
